var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1383 0C12.7528 0.00281268 14.2901 0.0150009 15.9241 0.0684417L16.504 0.0890679C18.1483 0.151884 19.7915 0.260641 20.6073 0.44534C21.6947 0.694731 22.5485 1.4204 22.8374 2.34108C23.2976 3.80368 23.3552 6.65573 23.3621 7.34671L23.3632 7.48922V7.65235C23.3552 8.34333 23.2976 11.1963 22.8374 12.658C22.5451 13.5815 21.6901 14.3081 20.6073 14.5537C19.7915 14.7384 18.1483 14.8472 16.504 14.91L15.9241 14.9316C14.2901 14.9841 12.7528 14.9972 12.1383 14.9991L11.8679 15H11.5745C10.2742 14.9934 4.83612 14.9456 3.1055 14.5537C2.01925 14.3043 1.1643 13.5787 0.875479 12.658C0.415207 11.1954 0.357673 8.34333 0.350769 7.65235V7.34671C0.357673 6.65573 0.415207 3.80274 0.875479 2.34108C1.16775 1.41759 2.02271 0.69098 3.10665 0.446278C4.83612 0.0534407 10.2754 0.00562535 11.5757 0H12.1383ZM9.55506 4.21901V10.7819L16.4591 7.50047L9.55506 4.21901Z",
    fill: "#C4E332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.618cba9974db000b90f37ef6c1b289a7.svg";
export { ForwardRef as ReactComponent };